import { Button } from "components/ui/button"
import { Badge } from "components/ui/badge"
import { Send, Loader2 } from "lucide-react"
import type { ResendConfirmationModalProps } from "../../types/components"
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogFooter,
} from "@/components/ui/alert-dialog"

export const ResendConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  selectedCount,
  isLoading,
  items
}: ResendConfirmationModalProps) => (
  <AlertDialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
    <AlertDialogContent
      className="max-w-md z-[60]"
      onEscapeKeyDown={(e) => e.stopPropagation()}
    >
      <AlertDialogHeader>
        <AlertDialogTitle className="text-lg font-semibold text-[#4B303C]">
          Reenviar Email
        </AlertDialogTitle>
      </AlertDialogHeader>

      <div className="space-y-4">
        <div className="p-3 bg-gray-50 border border-gray-200 rounded-lg">
          <p className="text-sm text-gray-800 font-medium mb-2">
            {`${selectedCount} item(s) pendente(s) para reenvio:`}
          </p>

          <div className="max-h-32 overflow-y-auto space-y-1">
            {items.map((item, index) => (
              <div key={index} className="flex items-center gap-2 text-xs text-gray-600 py-1">
                <Badge variant="outline" className="text-[10px] px-1.5 py-0">
                  {item.type === 'DIVERGENCE' ? 'Divergência' : 'NSU'}
                </Badge>
                <span className="truncate">{item.name}</span>
              </div>
            ))}
          </div>
        </div>

        <p className="text-sm text-gray-600">
          Este reenvio <strong>não criará uma nova solicitação</strong>. O email será enviado novamente
          para a loja com o mesmo link de resposta.
        </p>

        <p className="text-xs text-gray-500">
          Um registro de auditoria será criado para rastrear este reenvio.
        </p>
      </div>

      <AlertDialogFooter>
        <Button
          variant="outline"
          onClick={onClose}
          disabled={isLoading}
        >
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? (
            <Loader2 className="w-4 h-4 mr-1 animate-spin" />
          ) : (
            <Send className="w-4 h-4 mr-1" />
          )}
          {isLoading ? "Reenviando..." : "Confirmar Reenvio"}
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
)
